import BugsnagPerformance from "@bugsnag/browser-performance";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import React from "react";

const apiKey = "5b42b3a5a24ec646b7e8a3dd72b665e0";
const appVersion = process.env.EXPO_PUBLIC_APP_VERSION || "dev";
const releaseStage = appVersion === "dev" ? "development" : "production";

Bugsnag.start({
  apiKey,
  appVersion,
  enabledReleaseStages: ["production"],
  onError: (event) => {
    const msg = event.errors[0]?.errorMessage ?? "";
    if (
      msg.includes("Minified React error #418") ||
      msg.includes("Hydration")
    ) {
      return false;
    }
  },
  plugins: [new BugsnagPluginReact()],
  releaseStage,
});

BugsnagPerformance.start({ apiKey, releaseStage });

const BugsnagErrorBoundary =
  Bugsnag.getPlugin("react")!.createErrorBoundary(React);

export { BugsnagErrorBoundary };
export default Bugsnag;
